import React from 'react';
import { colors, fonts } from '../styles/theme';
import { useIsMobile } from '../hooks';

export function BetaInviteSection({
  analyticsLocation = 'site',
  fullBleed = false,
  style = {},
}) {
  const isMobile = useIsMobile(768);

  return (
    <section
      style={{
        width: fullBleed ? '100vw' : '100%',
        marginLeft: fullBleed ? 'calc(50% - 50vw)' : 0,
        marginRight: fullBleed ? 'calc(50% - 50vw)' : 0,
        padding: fullBleed
          ? (isMobile ? '24px 20px 56px' : '34px 34px 72px')
          : (isMobile ? '24px 0 36px' : '34px 0 46px'),
        ...style,
      }}
    >
      <div
        style={{
          maxWidth: fullBleed ? 940 : '100%',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1.25fr 0.75fr',
          gap: isMobile ? 24 : 34,
          alignItems: 'center',
          background: '#fff',
          border: `1px solid ${colors.border}`,
          borderRadius: 8,
          padding: isMobile ? '24px 20px' : '30px 34px',
          boxShadow: '0 18px 48px rgba(72, 53, 34, 0.07)',
        }}
      >
        <div>
          <p
            style={{
              margin: '0 0 8px',
              color: '#B84F05',
              fontSize: '0.82rem',
              fontWeight: 850,
            }}
          >
            Beta program
          </p>
          <h2
            style={{
              margin: '0 0 10px',
              color: colors.text,
              fontFamily: fonts.heading,
              fontSize: isMobile ? '1.8rem' : '2.35rem',
              fontWeight: 850,
              lineHeight: 1.04,
              letterSpacing: 0,
            }}
          >
            Get free Pro access and help shape Bhol.
          </h2>
          <p
            style={{
              margin: 0,
              color: colors.textLight,
              fontSize: '1rem',
              lineHeight: 1.6,
              maxWidth: 590,
            }}
          >
            Beta members get early access to new languages and features in exchange for feedback, plus a spot in the founders feedback community.
          </p>
        </div>

        <a
          href="/beta"
          data-analytics-click="beta_program_click"
          data-analytics-location={analyticsLocation}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: colors.text,
            color: '#fff',
            borderRadius: 8,
            minHeight: 48,
            padding: '0 22px',
            textDecoration: 'none',
            fontWeight: 800,
            boxShadow: '0 10px 26px rgba(0,0,0,0.16)',
          }}
        >
          Join the Beta
        </a>
      </div>
    </section>
  );
}

export default BetaInviteSection;
